export default __webpack_public_path__ + "static/media/Breastplate of Red Ruin (nm).dac4c4dd.jpg";